<template>
    <div id="settings">
        <b-container>
            <b-card class="shadow p-4">
                <h1 class="text-center">Preferencias</h1>
                <hr>
                <b-row>
                    <b-col cols="12" class="p-2">
                        <UserSettingsChangePassword/>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="12" class="p-2">
                        <UserSettingsChangeEmail/>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="12" class="p-2">
                        <UserSettingsChangeNotifications/>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import UserSettingsChangePassword from './UserSettingsChangePassword'
import UserSettingsChangeEmail from './UserSettingsChangeEmail'
import UserSettingsChangeNotifications from './UserSettingsChangeNotifications'

export default {
    name: 'UserSettings',
    components: {
        UserSettingsChangePassword,
        UserSettingsChangeEmail,
        UserSettingsChangeNotifications
    }
}
</script>
